
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator';
import ClosablePanel from '@/components/ClosablePanel.vue';

@Options({
  components: {
    ClosablePanel

  },

  watch: {
    opened (newOpenedValue) {
      this.isOpened = newOpenedValue;
    }
  }
})
export default class Modal extends Vue {
  @Prop({ default: false })
  opened!: boolean;

  public isOpened = this.opened;

  closeModal () {
    this.$emit('update:opened', false);
    this.isOpened = false;
    this.$emit('closed', true);
  }
}
